import React from 'react';

import { HelpScoutBeaconText } from '../typescript-types/ui-utility/help-scout-beacon-text';
import { UiButton } from '../ui/ui-button';
import { HOME_ROUTE } from '../web-routes';

import { HelpScout } from '../util/helpscout-beacon';

type Props = {
  message?: string;
  secondaryMessage?: string;
  showBeacon?: boolean;
  beaconText?: HelpScoutBeaconText;
};

export const NotFoundPage = ({
  message,
  secondaryMessage,
  beaconText: supportMessage,
  showBeacon,
}: Props) => {
  const handleHelpClick = () => {
    HelpScout.beacon.navigate('/ask/message/');
    if (supportMessage) {
      HelpScout.beacon.prefillText(supportMessage.subject, supportMessage.text);
    }
  };

  return (
    <div className="u-margin-0Auto u-padding-xl u-textAlign-center">
      <div className="typo-h4 u-margin-y-xl">
        {message ?? 'We are sorry. That page could not be found.'}
      </div>
      {secondaryMessage && <div className="typo-h5 u-margin-bottom-xl">{secondaryMessage}</div>}
      {showBeacon ? (
        <UiButton variant="primary" onClick={handleHelpClick}>
          Contact Support
        </UiButton>
      ) : (
        <UiButton linkTo={HOME_ROUTE}>Home</UiButton>
      )}
    </div>
  );
};
